module.exports = __webpack_public_path__ + "static/tutor-25b592c492de49038c6e26de8a90cd75.jpg";